import type {
  ILolaRecipient,
  IPayoutPaymentMethod,
} from "../shared/session/interfaces/session";

const PAYOUT_DETAIL_KEY: Record<string, keyof IPayoutPaymentMethod> = {
  bank_account: "bankAccount",
  cash: "cash",
  mobile_wallet: "mobileWallet",
  home_delivery: "homeDelivery",
};

function text(value: unknown): string | undefined {
  return typeof value === "string" && value.trim() ? value.trim() : undefined;
}

/**
 * Destination state pinned on a Lola claim. The payout block wins
 * (`cash.state`, `bankAccount.state` / `stateCode`), matching the route the
 * backend builds. The recipient address is only the fallback.
 */
export function resolveClaimStateCode(
  recipient: ILolaRecipient | undefined,
): string | undefined {
  const payout = recipient?.payoutMethod;
  if (payout) {
    const key = PAYOUT_DETAIL_KEY[payout.type];
    const details = key ? payout[key] : undefined;
    const block = details as { state?: string; stateCode?: string } | undefined;
    const fromPayout = text(block?.state) ?? text(block?.stateCode);
    if (fromPayout) return fromPayout;
  }
  return text(recipient?.address?.stateCode);
}
